<!-- 答辩小组 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 32.23">
    <title>答辩小组</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="23.64" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="23.64" rx="13.61" ry="6.79" />
        <circle class="cls-3" cx="14.96" cy="6.82" r="5.82" />
        <path
          class="cls-3"
          d="M15.45,12.61c-5.74,0-10.39,4.15-10.39,9.27L15.59,22"
        />
        <path
          class="cls-3"
          d="M24.66,1.85h.26a4.48,4.48,0,0,1,.64.08,4.71,4.71,0,0,1-.9,9.34m6.26,3a8.77,8.77,0,0,0-6.69-3"
        />
        <path
          class="cls-4"
          d="M20.42,17.36a3.23,3.23,0,0,0-.07.69V19a3.47,3.47,0,0,0,3.5,3.44h0A3.47,3.47,0,0,0,27.35,19v-.91a4,4,0,0,0,0-.49.17.17,0,0,1,0-.07"
        />
        <path
          class="cls-4"
          d="M29.24,16.73l-5.17,1.74a.37.37,0,0,1-.21,0l-5.4-1.76a.33.33,0,0,1,0-.63l5-1.42a.37.37,0,0,1,.18,0l5.56,1.45A.33.33,0,0,1,29.24,16.73Z"
        />
        <line class="cls-4" x1="18.54" y1="19.88" x2="18.54" y2="17.18" />
        <ellipse class="cls-5" cx="18.53" cy="22.01" rx="0.82" ry="0.81" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 32.23">
    <title>答辩小组</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="23.64" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="23.64" rx="13.61" ry="6.79" />
        <circle class="cls-3" cx="14.96" cy="6.82" r="5.82" />
        <path
          class="cls-3"
          d="M15.45,12.61c-5.74,0-10.39,4.15-10.39,9.27L15.59,22"
        />
        <path
          class="cls-3"
          d="M24.66,1.85h.26a4.48,4.48,0,0,1,.64.08,4.71,4.71,0,0,1-.9,9.34m6.26,3a8.77,8.77,0,0,0-6.69-3"
        />
        <path
          class="cls-3"
          d="M20.42,17.36a3.23,3.23,0,0,0-.07.69V19a3.47,3.47,0,0,0,3.5,3.44h0A3.47,3.47,0,0,0,27.35,19v-.91a4,4,0,0,0,0-.49.17.17,0,0,1,0-.07"
        />
        <path
          class="cls-3"
          d="M29.24,16.73l-5.17,1.74a.37.37,0,0,1-.21,0l-5.4-1.76a.33.33,0,0,1,0-.63l5-1.42a.37.37,0,0,1,.18,0l5.56,1.45A.33.33,0,0,1,29.24,16.73Z"
        />
        <line class="cls-4" x1="18.54" y1="19.88" x2="18.54" y2="17.18" />
        <ellipse class="cls-5" cx="18.59" cy="21.85" rx="0.82" ry="0.81" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35 32.09">
    <title>答辩小组</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.5" cy="23.54" rx="17.5" ry="8.55" />
        <ellipse class="cls-2" cx="17.44" cy="23.55" rx="13.54" ry="6.76" />
        <circle class="cls-3" cx="14.85" cy="6.67" r="5.78" />
        <path
          class="cls-3"
          d="M15.34,12.42C9.64,12.42,5,16.55,5,21.64l10.45.1"
        />
        <path
          class="cls-3"
          d="M24.49,1.73h.26a4.48,4.48,0,0,1,.64.08,4.68,4.68,0,0,1-.9,9.28m6.22,3a8.72,8.72,0,0,0-6.65-2.94"
        />
        <path
          class="cls-4"
          d="M20.28,17.15a3.08,3.08,0,0,0-.07.68v.9a3.44,3.44,0,0,0,3.48,3.42h0a3.44,3.44,0,0,0,3.47-3.42v-.9a3.91,3.91,0,0,0,0-.49s0-.05,0-.07"
        />
        <path
          class="cls-4"
          d="M29,16.51,23.9,18.24a.26.26,0,0,1-.21,0l-5.36-1.75a.32.32,0,0,1,0-.62l5-1.42h.17L29,15.89A.32.32,0,0,1,29,16.51Z"
        />
        <line class="cls-5" x1="18.41" y1="19.64" x2="18.41" y2="16.96" />
        <ellipse class="cls-6" cx="18.41" cy="21.46" rx="0.79" ry="0.78" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3,
    .cls-4 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2px;
    }
    .cls-4 {
      stroke-width: 1.5px;
    }
    .cls-5 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3,
    .cls-4 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2px;
    }
    .cls-5 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3,
    .cls-4,
    .cls-5 {
      fill: none;
      stroke: #34aa91;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 1.77px;
    }
    .cls-4 {
      stroke-width: 1.34px;
    }
    .cls-5 {
      stroke-width: 1.29px;
    }
    .cls-6 {
      fill: #34aa91;
    }
  }
</style>
